import React from 'react';

import logo from "../images/logo-dpec-01.svg";

const Banner = () => {

  // Mantener comentado hasta que requieran lo contrario
  // function handleClose() {
  //   window.close();
  // }

  return (
    <div className={"bg-dpecGreen"}>
      <div className={"max-w-7xl mx-auto py-2 px-2 sm:px-6 lg:px-8"}>
        <div className={"flex items-center justify-between flex-wrap"}>
          <span className={"flex text-lg font-bold"}>
            <img src={logo} alt={"logo DPEC"} className={"header-logo"}/>
          </span>
          <div className={"max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8"}>
            <div className={"flex items-center justify-between flex-wrap"}>
              <div className={"h-4 order-2 flex-shrink-0 sm:order-2 sm:ml-2"}></div>
            </div>
          </div>
          {/* Mantener comentado hasta que requieran lo contrario */}
          {/* <div className="text-green-800 max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div
              className="absolute top-4 right-5 | cursor-default hover:text-gray-200"
              onClick={handleClose}
            >
              &#10006;
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Banner
